// package: clientconfig
// file: clientconfig/model.proto

import * as common_app from "../common/app";
import * as common_platform from "../common/platform";
import * as user_base_model from "../user/base/model";
import * as common_version from "../common/version";

export const PathVersion = {
    encode(object) {
        const message = {};
        if (object.path != null) {
            if (object.path !== "") {
                message.path = String(object.path);
            }
        }
        if (object.version != null) {
            if (object.version !== "") {
                message.version = String(object.version);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            path: "",
            version: "",
        };

        if (message.path != null) {
            object.path = message.path;
        }
        if (message.version != null) {
            object.version = message.version;
        }
        return object;
    },
};

export const WechatShareConfig = {
    encode(object) {
        const message = {};
        if (object.ID != null) {
            if (object.ID !== "") {
                message.ID = String(object.ID);
            }
        }
        if (object.weChatShareTypeID != null) {
            if (object.weChatShareTypeID !== "") {
                message.weChatShareTypeID = String(object.weChatShareTypeID);
            }
        }
        if (object.title != null) {
            if (object.title !== "") {
                message.title = String(object.title);
            }
        }
        if (object.subtitle != null) {
            if (object.subtitle !== "") {
                message.subtitle = String(object.subtitle);
            }
        }
        if (object.imageURL != null) {
            if (object.imageURL !== "") {
                message.imageURL = String(object.imageURL);
            }
        }
        if (object.shareStyle != null) {
            if (object.shareStyle !== 0) {
                message.shareStyle = object.shareStyle;
            }
        }
        if (object.wechatShareConfigStatus != null) {
            if (object.wechatShareConfigStatus !== 0) {
                message.wechatShareConfigStatus = object.wechatShareConfigStatus;
            }
        }
        if (object.abTest != null) {
            if (object.abTest !== "") {
                message.abTest = String(object.abTest);
            }
        }
        if (object.tag != null) {
            if (object.tag !== "") {
                message.tag = String(object.tag);
            }
        }
        if (object.createdTime != null) {
            if (object.createdTime !== 0) {
                message.createdTime = String(object.createdTime);
            }
        }
        if (object.updatedTime != null) {
            if (object.updatedTime !== 0) {
                message.updatedTime = String(object.updatedTime);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            ID: "",
            weChatShareTypeID: "",
            title: "",
            subtitle: "",
            imageURL: "",
            shareStyle: 0,
            wechatShareConfigStatus: 0,
            abTest: "",
            tag: "",
            createdTime: 0,
            updatedTime: 0,
        };

        if (message.ID != null) {
            object.ID = message.ID;
        }
        if (message.weChatShareTypeID != null) {
            object.weChatShareTypeID = message.weChatShareTypeID;
        }
        if (message.title != null) {
            object.title = message.title;
        }
        if (message.subtitle != null) {
            object.subtitle = message.subtitle;
        }
        if (message.imageURL != null) {
            object.imageURL = message.imageURL;
        }
        if (message.shareStyle != null) {
            object.shareStyle = message.shareStyle;
        }
        if (message.wechatShareConfigStatus != null) {
            object.wechatShareConfigStatus = message.wechatShareConfigStatus;
        }
        if (message.abTest != null) {
            object.abTest = message.abTest;
        }
        if (message.tag != null) {
            object.tag = message.tag;
        }
        if (message.createdTime != null) {
            object.createdTime = parseInt(message.createdTime, 10);
        }
        if (message.updatedTime != null) {
            object.updatedTime = parseInt(message.updatedTime, 10);
        }
        return object;
    },
};

export const WechatShareTypeConfig = {
    encode(object) {
        const message = {};
        if (object.ID != null) {
            if (object.ID !== "") {
                message.ID = String(object.ID);
            }
        }
        if (object.name != null) {
            if (object.name !== "") {
                message.name = String(object.name);
            }
        }
        if (object.englishName != null) {
            if (object.englishName !== "") {
                message.englishName = String(object.englishName);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            ID: "",
            name: "",
            englishName: "",
        };

        if (message.ID != null) {
            object.ID = message.ID;
        }
        if (message.name != null) {
            object.name = message.name;
        }
        if (message.englishName != null) {
            object.englishName = message.englishName;
        }
        return object;
    },
};

export const VersionConfig = {
    encode(object) {
        const message = {};
        if (object.ID != null) {
            if (object.ID !== "") {
                message.ID = String(object.ID);
            }
        }
        if (object.platform != null) {
            if (object.platform !== 0) {
                message.platform = object.platform;
            }
        }
        if (object.desc != null) {
            if (object.desc !== "") {
                message.desc = String(object.desc);
            }
        }
        if (object.appStoreURL != null) {
            if (object.appStoreURL !== "") {
                message.appStoreURL = String(object.appStoreURL);
            }
        }
        if (object.apkDownloadURL != null) {
            if (object.apkDownloadURL !== "") {
                message.apkDownloadURL = String(object.apkDownloadURL);
            }
        }
        if (object.version != null) {
            if (object.version !== "") {
                message.version = String(object.version);
            }
        }
        if (object.forceUpgrade != null) {
            if (object.forceUpgrade !== false) {
                message.forceUpgrade = Boolean(object.forceUpgrade);
            }
        }
        if (object.nvol != null) {
            if (object.nvol !== 0) {
                message.nvol = object.nvol | 0;
            }
        }
        if (object.apk64DownloadURL != null) {
            if (object.apk64DownloadURL !== "") {
                message.apk64DownloadURL = String(object.apk64DownloadURL);
            }
        }
        if (object.grayRelease != null) {
            if (object.grayRelease !== false) {
                message.grayRelease = Boolean(object.grayRelease);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            ID: "",
            platform: 0,
            desc: "",
            appStoreURL: "",
            apkDownloadURL: "",
            version: "",
            forceUpgrade: false,
            nvol: 0,
            apk64DownloadURL: "",
            grayRelease: false,
        };

        if (message.ID != null) {
            object.ID = message.ID;
        }
        if (message.platform != null) {
            object.platform = message.platform;
        }
        if (message.desc != null) {
            object.desc = message.desc;
        }
        if (message.appStoreURL != null) {
            object.appStoreURL = message.appStoreURL;
        }
        if (message.apkDownloadURL != null) {
            object.apkDownloadURL = message.apkDownloadURL;
        }
        if (message.version != null) {
            object.version = message.version;
        }
        if (message.forceUpgrade != null) {
            object.forceUpgrade = message.forceUpgrade;
        }
        if (message.nvol != null) {
            object.nvol = message.nvol;
        }
        if (message.apk64DownloadURL != null) {
            object.apk64DownloadURL = message.apk64DownloadURL;
        }
        if (message.grayRelease != null) {
            object.grayRelease = message.grayRelease;
        }
        return object;
    },
};

export const NoticePosition = {
    encode(object) {
        const message = {};
        if (object.ID != null) {
            if (object.ID !== "") {
                message.ID = String(object.ID);
            }
        }
        if (object.name != null) {
            if (object.name !== "") {
                message.name = String(object.name);
            }
        }
        if (object.noticePositionStatus != null) {
            if (object.noticePositionStatus !== 0) {
                message.noticePositionStatus = object.noticePositionStatus;
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            ID: "",
            name: "",
            noticePositionStatus: 0,
        };

        if (message.ID != null) {
            object.ID = message.ID;
        }
        if (message.name != null) {
            object.name = message.name;
        }
        if (message.noticePositionStatus != null) {
            object.noticePositionStatus = message.noticePositionStatus;
        }
        return object;
    },
};

export const Notice = {
    encode(object) {
        const message = {};
        if (object.ID != null) {
            if (object.ID !== "") {
                message.ID = String(object.ID);
            }
        }
        if (object.image != null) {
            if (object.image !== "") {
                message.image = String(object.image);
            }
        }
        if (object.title != null) {
            if (object.title !== "") {
                message.title = String(object.title);
            }
        }
        if (object.link != null) {
            if (object.link !== "") {
                message.link = String(object.link);
            }
        }
        if (object.noticePositionID != null) {
            if (object.noticePositionID !== "") {
                message.noticePositionID = String(object.noticePositionID);
            }
        }
        if (object.platform != null) {
            if (object.platform !== 0) {
                message.platform = object.platform;
            }
        }
        if (object.startTime != null) {
            if (object.startTime !== 0) {
                message.startTime = String(object.startTime);
            }
        }
        if (object.endTime != null) {
            if (object.endTime !== 0) {
                message.endTime = String(object.endTime);
            }
        }
        if (object.status != null) {
            if (object.status !== 0) {
                message.status = object.status;
            }
        }
        if (object.sort != null) {
            if (object.sort !== 0) {
                message.sort = String(object.sort);
            }
        }
        if (object.character != null) {
            if (!Array.isArray(object.character)) {
                throw TypeError("character: array expected");
            }
            if (object.character.length > 0) {
                message.character = [];
                for (let i = 0; i < object.character.length; ++i) {
                    message.character[i] = object.character[i];
                }
            }
        }
        if (object.attrs != null) {
            if (typeof object.attrs !== "object") {
                throw TypeError("attrs: object expected");
            }
            const keys = Object.keys(object.attrs);
            if (keys.length > 0) {
                message.attrs = {};
                for (let i = 0; i < keys.length; ++i) {
                    if (object.attrs[keys[i]] !== "") {
                        message.attrs[keys[i]] = String(object.attrs[keys[i]]);
                    }
                }
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            ID: "",
            image: "",
            title: "",
            link: "",
            noticePositionID: "",
            platform: 0,
            startTime: 0,
            endTime: 0,
            status: 0,
            sort: 0,
            character: [],
            attrs: {},
        };

        if (message.ID != null) {
            object.ID = message.ID;
        }
        if (message.image != null) {
            object.image = message.image;
        }
        if (message.title != null) {
            object.title = message.title;
        }
        if (message.link != null) {
            object.link = message.link;
        }
        if (message.noticePositionID != null) {
            object.noticePositionID = message.noticePositionID;
        }
        if (message.platform != null) {
            object.platform = message.platform;
        }
        if (message.startTime != null) {
            object.startTime = parseInt(message.startTime, 10);
        }
        if (message.endTime != null) {
            object.endTime = parseInt(message.endTime, 10);
        }
        if (message.status != null) {
            object.status = message.status;
        }
        if (message.sort != null) {
            object.sort = parseInt(message.sort, 10);
        }
        if (message.character != null) {
            object.character = [];
            for (let i = 0; i < message.character.length; ++i) {
                    object.character[i] = message.character[i];
            }
        }
        if (message.attrs != null) {
            const keys = Object.keys(message.attrs);
            object.attrs = {};
            for (let i = 0; i < keys.length; ++i) {
                    object.attrs[keys[i]] = message.attrs[keys[i]];
            }
        }
        return object;
    },
};

export const BannerPosition = {
    encode(object) {
        const message = {};
        if (object.ID != null) {
            if (object.ID !== "") {
                message.ID = String(object.ID);
            }
        }
        if (object.name != null) {
            if (object.name !== "") {
                message.name = String(object.name);
            }
        }
        if (object.status != null) {
            if (object.status !== 0) {
                message.status = object.status;
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            ID: "",
            name: "",
            status: 0,
        };

        if (message.ID != null) {
            object.ID = message.ID;
        }
        if (message.name != null) {
            object.name = message.name;
        }
        if (message.status != null) {
            object.status = message.status;
        }
        return object;
    },
};

export const Banner = {
    encode(object) {
        const message = {};
        if (object.ID != null) {
            if (object.ID !== "") {
                message.ID = String(object.ID);
            }
        }
        if (object.image != null) {
            if (object.image !== "") {
                message.image = String(object.image);
            }
        }
        if (object.title != null) {
            if (object.title !== "") {
                message.title = String(object.title);
            }
        }
        if (object.link != null) {
            if (object.link !== "") {
                message.link = String(object.link);
            }
        }
        if (object.bannerPositionID != null) {
            if (object.bannerPositionID !== "") {
                message.bannerPositionID = String(object.bannerPositionID);
            }
        }
        if (object.platform != null) {
            if (object.platform !== 0) {
                message.platform = object.platform;
            }
        }
        if (object.character != null) {
            if (!Array.isArray(object.character)) {
                throw TypeError("character: array expected");
            }
            if (object.character.length > 0) {
                message.character = [];
                for (let i = 0; i < object.character.length; ++i) {
                    message.character[i] = object.character[i];
                }
            }
        }
        if (object.attrs != null) {
            if (typeof object.attrs !== "object") {
                throw TypeError("attrs: object expected");
            }
            const keys = Object.keys(object.attrs);
            if (keys.length > 0) {
                message.attrs = {};
                for (let i = 0; i < keys.length; ++i) {
                    if (object.attrs[keys[i]] !== "") {
                        message.attrs[keys[i]] = String(object.attrs[keys[i]]);
                    }
                }
            }
        }
        if (object.order != null) {
            if (object.order !== 0) {
                message.order = String(object.order);
            }
        }
        if (object.status != null) {
            if (object.status !== 0) {
                message.status = object.status;
            }
        }
        if (object.startTime != null) {
            if (object.startTime !== 0) {
                message.startTime = String(object.startTime);
            }
        }
        if (object.endTime != null) {
            if (object.endTime !== 0) {
                message.endTime = String(object.endTime);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            ID: "",
            image: "",
            title: "",
            link: "",
            bannerPositionID: "",
            platform: 0,
            character: [],
            attrs: {},
            order: 0,
            status: 0,
            startTime: 0,
            endTime: 0,
        };

        if (message.ID != null) {
            object.ID = message.ID;
        }
        if (message.image != null) {
            object.image = message.image;
        }
        if (message.title != null) {
            object.title = message.title;
        }
        if (message.link != null) {
            object.link = message.link;
        }
        if (message.bannerPositionID != null) {
            object.bannerPositionID = message.bannerPositionID;
        }
        if (message.platform != null) {
            object.platform = message.platform;
        }
        if (message.character != null) {
            object.character = [];
            for (let i = 0; i < message.character.length; ++i) {
                    object.character[i] = message.character[i];
            }
        }
        if (message.attrs != null) {
            const keys = Object.keys(message.attrs);
            object.attrs = {};
            for (let i = 0; i < keys.length; ++i) {
                    object.attrs[keys[i]] = message.attrs[keys[i]];
            }
        }
        if (message.order != null) {
            object.order = parseInt(message.order, 10);
        }
        if (message.status != null) {
            object.status = message.status;
        }
        if (message.startTime != null) {
            object.startTime = parseInt(message.startTime, 10);
        }
        if (message.endTime != null) {
            object.endTime = parseInt(message.endTime, 10);
        }
        return object;
    },
};

export const NewsList = {
    encode(object) {
        const message = {};
        if (object.texts != null) {
            if (!Array.isArray(object.texts)) {
                throw TypeError("texts: array expected");
            }
            if (object.texts.length > 0) {
                message.texts = [];
                for (let i = 0; i < object.texts.length; ++i) {
                    message.texts[i] = NewsText.encode(object.texts[i]);
                }
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            texts: [],
        };

        if (message.texts != null) {
            object.texts = [];
            for (let i = 0; i < message.texts.length; ++i) {
                object.texts[i] = NewsText.decode(message.texts[i]);
            }
        }
        return object;
    },
};

export const NewsText = {
    encode(object) {
        const message = {};
        if (object.style != null) {
            if (object.style !== 0) {
                message.style = object.style;
            }
        }
        if (object.text != null) {
            if (object.text !== "") {
                message.text = String(object.text);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            style: 0,
            text: "",
        };

        if (message.style != null) {
            object.style = message.style;
        }
        if (message.text != null) {
            object.text = message.text;
        }
        return object;
    },
};

export const NewsListV2 = {
    encode(object) {
        const message = {};
        if (object.news != null) {
            if (!Array.isArray(object.news)) {
                throw TypeError("news: array expected");
            }
            if (object.news.length > 0) {
                message.news = [];
                for (let i = 0; i < object.news.length; ++i) {
                    message.news[i] = News.encode(object.news[i]);
                }
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            news: [],
        };

        if (message.news != null) {
            object.news = [];
            for (let i = 0; i < message.news.length; ++i) {
                object.news[i] = News.decode(message.news[i]);
            }
        }
        return object;
    },
};

export const News = {
    encode(object) {
        const message = {};
        let data_ = false;
        if (object.type != null) {
            if (object.type !== 0) {
                message.type = object.type;
            }
        }
        if (object.image != null && !data_) {
            message.image = String(object.image);
            data_ = true;
        }
        if (object.text != null && !data_) {
            message.text = String(object.text);
            data_ = true;
        }
        if (object.style != null) {
            if (object.style !== 0) {
                message.style = object.style;
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            type: 0,
            style: 0,
        };

        if (message.type != null) {
            object.type = message.type;
        }
        if (message.image != null) {
            object.image = message.image;
            object.data = "image";
        }
        if (message.text != null) {
            object.text = message.text;
            object.data = "text";
        }
        if (message.style != null) {
            object.style = message.style;
        }
        return object;
    },
};

export const SaveMoneyCardFreeBuyComment = {
    encode(object) {
        const message = {};
        if (object.nickname != null) {
            if (object.nickname !== "") {
                message.nickname = String(object.nickname);
            }
        }
        if (object.avatar != null) {
            if (object.avatar !== "") {
                message.avatar = String(object.avatar);
            }
        }
        if (object.comment != null) {
            if (object.comment !== "") {
                message.comment = String(object.comment);
            }
        }
        if (object.commentAt != null) {
            if (object.commentAt !== 0) {
                message.commentAt = String(object.commentAt);
            }
        }
        if (object.amount != null) {
            if (object.amount !== 0) {
                message.amount = String(object.amount);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            nickname: "",
            avatar: "",
            comment: "",
            commentAt: 0,
            amount: 0,
        };

        if (message.nickname != null) {
            object.nickname = message.nickname;
        }
        if (message.avatar != null) {
            object.avatar = message.avatar;
        }
        if (message.comment != null) {
            object.comment = message.comment;
        }
        if (message.commentAt != null) {
            object.commentAt = parseInt(message.commentAt, 10);
        }
        if (message.amount != null) {
            object.amount = parseInt(message.amount, 10);
        }
        return object;
    },
};

export const CMSVersionConfig = {
    encode(object) {
        const message = {};
        if (object.versionConfig != null) {
            message.versionConfig = VersionConfig.encode(object.versionConfig);
        }
        if (object.app != null) {
            if (object.app !== 0) {
                message.app = object.app;
            }
        }
        if (object.grayReleaseSwitch != null) {
            if (object.grayReleaseSwitch !== false) {
                message.grayReleaseSwitch = Boolean(object.grayReleaseSwitch);
            }
        }
        if (object.grayReleaseRate != null) {
            if (object.grayReleaseRate !== 0) {
                message.grayReleaseRate = String(object.grayReleaseRate);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            versionConfig: null,
            app: 0,
            grayReleaseSwitch: false,
            grayReleaseRate: 0,
        };

        if (message.versionConfig != null) {
            object.versionConfig = VersionConfig.decode(message.versionConfig);
        }
        if (message.app != null) {
            object.app = message.app;
        }
        if (message.grayReleaseSwitch != null) {
            object.grayReleaseSwitch = message.grayReleaseSwitch;
        }
        if (message.grayReleaseRate != null) {
            object.grayReleaseRate = parseInt(message.grayReleaseRate, 10);
        }
        return object;
    },
};

export const AppReviewVersion = {
    encode(object) {
        const message = {};
        if (object.ID != null) {
            if (object.ID !== "") {
                message.ID = String(object.ID);
            }
        }
        if (object.app != null) {
            if (object.app !== 0) {
                message.app = object.app;
            }
        }
        if (object.channel != null) {
            if (object.channel !== "") {
                message.channel = String(object.channel);
            }
        }
        if (object.version != null) {
            message.version = common_version.Version.encode(object.version);
        }
        if (object.isReview != null) {
            if (object.isReview !== false) {
                message.isReview = Boolean(object.isReview);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            ID: "",
            app: 0,
            channel: "",
            version: null,
            isReview: false,
        };

        if (message.ID != null) {
            object.ID = message.ID;
        }
        if (message.app != null) {
            object.app = message.app;
        }
        if (message.channel != null) {
            object.channel = message.channel;
        }
        if (message.version != null) {
            object.version = common_version.Version.decode(message.version);
        }
        if (message.isReview != null) {
            object.isReview = message.isReview;
        }
        return object;
    },
};


export const NoticeStatus = {
    NOTICE_STATUS_UNDEFINED: 0,
    NOTICE_STATUS_ONLINE: 1,
    NOTICE_STATUS_OFFLINE: 2,
    NOTICE_STATUS_DELETED: 3,
};


export const ShareStyle = {
    SHARE_STYLE_UNDEFINED: 0,
    SHARE_STYLE_CARD: 1,
    SHARE_STYLE_POSTER: 2,
};


export const ScreenType = {
    SCREEN_TYPE_UNDEFINED: 0,
    SCREEN_TYPE_REACT_H5: 1,
    SCREEN_TYPE_VUE_H5: 2,
};


export const WechatShareConfigStatus = {
    WECHAT_SHARE_CONFIG_STATUS_UNDEFINED: 0,
    WECHAT_SHARE_CONFIG_STATUS_ONLINE: 1,
    WECHAT_SHARE_CONFIG_STATUS_OFFLINE: 2,
};


export const NoticePositionStatus = {
    NOTICE_POSITION_STATUS_UNDEFINED: 0,
    NOTICE_POSITION_STATUS_ONLINE: 1,
    NOTICE_POSITION_STATUS_OFFLINE: 2,
    NOTICE_POSITION_STATUS_DELETED: 3,
};


export const BannerStatus = {
    BANNER_STATUS_UNDEFINED: 0,
    BANNER_STATUS_ONLINE: 1,
    BANNER_STATUS_OFFLINE: 2,
    BANNER_STATUS_DELETED: 3,
};


export const TextStyle = {
    TEXT_STYLE_UNDEFINED: 0,
    TEXT_STYLE_HIGHLIGHT: 1,
};


export const NewsType = {
    NEWS_TYPE_UNDEFINED: 0,
    NEWS_TYPE_IMAGE: 1,
    NEWS_TYPE_TEXT: 2,
};


export const OrderPassBackStatus = {
    ORDER_PASS_BACK_STATUS_UNDEFINED: 0,
    ORDER_PASS_BACK_STATUS_ONLINE: 1,
    ORDER_PASS_BACK_STATUS_OFFLINE: 2,
};


export const OrderPassBackType = {
    ORDER_PASS_BACK_TYPE_UNDEFINED: 0,
    ORDER_PASS_BACK_TYPE_RANDOM: 1,
    ORDER_PASS_BACK_TYPE_USER_TK: 2,
};


